import React from 'react';
import styled from '@emotion/styled';
import MadlanLogoIcon from 'assets/svg/madlan-small-green-logo.svg';


const LoadingWrapper = styled.div`
  width: 88px;
  height: 88px;
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.neutrals.grey10};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const IconWrapper = styled.div`
  position: relative;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  z-index: 2;
`;

const LineWrapper = styled.div`
  @keyframes rotating {
    from {
      transform: translateX(-50%) translateY(-50%) rotate(0deg);
    }
    to {
      transform: translateX(-50%) translateY(-50%) rotate(360deg);
    }
  }

  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(0);
  background-color: ${({ theme }) => theme.colors.neutrals.grey8};
  border-radius: ${({ theme }) => theme.borderRadius.round};
  overflow: hidden;
  z-index: 1;
  animation: rotating 3.5s linear infinite;
  &:before {
    content: '';
    width: 0;
    height: 0;
    border: 44px solid transparent;
    border-top-color: ${({ theme }) => theme.colors.brand.madlanGreen};
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const LogoLoader: React.FC = () => {
  return (
    <LoadingWrapper>
      <IconWrapper>
        <MadlanLogoIcon />
      </IconWrapper>
      <LineWrapper />
    </LoadingWrapper>
  );
};
